@if(!createButton) {
  <app-modal-response-fast 
    [previewOnly]="true" 
  /> 

  <div class="modal-footer">
    <button type="button" class="btn btn-light" [mat-dialog-close]="true" aria-hidden="true">
      {{ 'attendance.sendButtons.cancel' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="createButtons()">
      {{ 'attendance.sendButtons.createButtons' | translate }}
    </button>
  </div>
}

@if(createButton) {
  <div role="dialog" aria-labelledby="modalSendButtonsAttendance" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="modalSendButtonsAttendance">
            {{ 'attendance.sendButtons.title' | translate }}
            <br>
            <span class="text-muted fw-normal font-14">{{ 'attendance.sendButtons.subtitle' | translate }}</span>
          </h4>
          <button type="button" class="btn-close" [mat-dialog-close]="true" aria-hidden="true"></button>
        </div>
        <div class="modal-body custom-scroll-bar">
          <div class="row">
            <app-button-zapi-component 
              [buttonActionsArray]="getButtonActionsFormArray()" 
              [maxButtons]="3"
              [showFullMessage]="true"
              [title]="formGroup.get('title').value"
              [message]="formGroup.get('message').value"
              [footer]="formGroup.get('footer').value"
              (titleChange)="formGroup.get('title').setValue($event)"
              (messageChange)="formGroup.get('message').setValue($event)"
              (footerChange)="formGroup.get('footer').setValue($event)"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            (click)="closeModal()"
            class="btn btn-light"
          >
            {{ 'attendance.sendButtons.cancel' | translate }}
          </button>
          <button
            type="button"
            [disabled]="!formGroup.valid"
            (click)="sendMessage()"
            class="btn btn-primary"
          >
            {{ 'attendance.sendButtons.send' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
}